<template>
  <div ref="scroll" class="body" :class="{ hidden: moreVisible }">
    <div class="ad" v-if="adList.length">
      <van-swipe class="swiper" :autoplay="3000" @change="current = $event + 1">
        <van-swipe-item
          v-for="(item, i) of adList"
          :key="i"
          @click="toPage(item.href)"
        >
          <img :src="item.img_url" alt="" class="icon" />
        </van-swipe-item>
        <template #indicator>
          <div class="indicator">
            <div
              v-for="i of adList.length"
              :key="i"
              class="item"
              :class="{ active: current == i }"
            ></div>
          </div>
        </template>
      </van-swipe>
    </div>
    <div class="block">
      <div class="tabs" v-if="tabs.length">
        <div ref="tabs" class="items">
          <div
            :ref="`tab-${i}`"
            v-for="(tab, i) of tabs"
            :key="i"
            class="item"
            :class="{ active: cateId == tab.id }"
            @click="changeTab(tab, i, false)"
          >
            {{ tab.name }}
          </div>
        </div>
        <div class="more" @click="moreVisible = !moreVisible">
          <span class="label">{{ moreVisible ? "收起" : "展开" }}</span>
          <img
            src="@/assets/groupRob/arrow.png"
            class="icon"
            :class="{ rotate: moreVisible }"
            alt=""
          />
        </div>
      </div>
      <div v-if="moreVisible" class="navs">
        <div
          v-for="(tab, i) of tabs"
          :key="i"
          class="item"
          :class="{ active: cateId == tab.id }"
          @click="changeTab(tab, i, true)"
        >
          {{ tab.name }}
        </div>
      </div>
    </div>
    <div class="tools" :class="{ t: tabs.length }">
      <div class="sort">
        <div
          class="item"
          :class="{ active: !sort.order }"
          @click="changeSort(null)"
        >
          综合排序
        </div>
        <div
          class="item"
          :class="{ active: sort.order == 'factory_price' }"
          @click="changeSort('factory_price')"
        >
          <span>价格</span>
          <img
            v-if="sort.order == 'factory_price'"
            src="@/assets/groupRob/sort-s.png"
            class="icon"
            alt=""
          />
          <img v-else src="@/assets/groupRob/sort.png" class="icon" alt="" />
        </div>
      </div>
      <div @click="toggleArrange">
        <img
          v-if="column"
          src="@/assets/groupRob/toggle.png"
          class="toggle"
          alt=""
        />
        <img
          v-else
          src="@/assets/groupRob/toggle-2.png"
          class="toggle"
          alt=""
        />
      </div>
    </div>
    <div class="shadow-list">
      <div class="nav-shadow" :class="{ show: moreVisible }"></div>
      <div class="scroll">
        <van-pull-refresh
          class="container"
          v-model="refreshing"
          @refresh="onRefresh"
        >
          <van-list
            class="list"
            v-model="loading"
            :finished="finished"
            :error.sync="error"
            :immediate-check="false"
            error-text="发生异常，请刷新！"
            finished-text="没有更多了"
            @load="onLoad"
            :class="{ falls: !column }"
          >
            <!-- 单列 -->
            <template v-if="column">
              <div class="item" v-for="(item, i) of list" :key="i">
                <div class="goods" @click="toGoods(item.goods_id)">
                  <div class="thumb">
                    <img :src="item.image" alt="" class="icon" />
                  </div>
                  <div class="info">
                    <div class="title">
                      {{ item.goods_name }}
                    </div>
                    <div class="other">
                      <div>
                        <div class="price">
                          <span>工厂价</span>
                          <span class="rmb">¥</span>
                          <span class="large">{{ item.factory_price }}</span>
                        </div>
                        <div class="desc">
                          <span>原价</span>
                          <span class="del">￥{{ item.origin_price }}</span>
                        </div>
                      </div>
                      <div class="btn">立即报名</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 两列 -->
            <template v-else>
              <div
                class="item-column"
                v-for="(item, i) of list"
                :key="i"
                @click="toGoods(item.goods_id)"
              >
                <img :src="item.image" alt="" class="thumb" />
                <div class="title">
                  <span>{{ item.goods_name }}</span>
                </div>
                <div class="price">
                  <div class="now">
                    <!-- <span>工厂价¥</span> -->
                    <span>¥</span>
                    <span class="large">{{ item._price_l }}</span>
                    <span class="small">.{{ item._price_s }}</span>
                  </div>
                  <!-- <div class="old">原价:¥{{ item.origin_price }}</div> -->
                  <div class="old">¥{{ item.origin_price }}</div>
                </div>
                <div class="btn">立即报名</div>
              </div>
            </template>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      page: 0,
      list: [],
      column: false, //单列排列方式
      adList: [],
      current: 0,
      moreVisible: false,
      tabs: [],
      sort: {
        order: null,
        by: "desc",
      },
      cateId: null,
      memberId: null,
    };
  },
  created() {
    this.$api
      .post("adspace/index/get/ad/list", {
        labels: ["shallBuy_collage_seckill_index_top"],
      })
      .then((res) => {
        if (res["shallBuy_collage_seckill_index_top"]) {
          this.adList = res["shallBuy_collage_seckill_index_top"];
        }
      });
  },
  mounted() {
    this.$api
      .get("member/member/user/detail")
      .then((res) => {
        this.memberId = res.id;
      })
      .finally(() => {
        this.$api.get("activity/index/panic/get-cate-list").then((res) => {
          this.tabs = res || [];
          this.$nextTick(() => this.changeTab(this.tabs[0]));
        });
      });
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.error = false;
      this.loading = true;
      this.page = 0;
      this.onLoad();
      this.$refs.scroll.scrollTop = 0;
    },
    onLoad() {
      if (this.finished) {
        return;
      }
      if (!this.refreshing) {
        this.loading = true;
      }
      let params = {
        cate_id: this.cateId,
        page: ++this.page,
        pageSize: 10,
      };
      if (this.sort.order) {
        params.order = this.sort;
      }
      if (this.memberId) {
        params.member_id = this.memberId;
      }
      this.$api
        .post("activity/index/panic/panic-list", params)
        .then((res) => {
          res.list.forEach((_) => {
            if (_.factory_price) {
              let _temp = _.factory_price.split(".");
              _._price_l = _temp[0];
              _._price_s = _temp[1] || "00";
            }
          });
          if (this.page == 1) {
            this.list = res.list;
          } else {
            this.list = this.list.concat(res.list);
          }
          this.finished = res.current_page >= res.last_page;
        })
        .catch((e) => (this.error = true))
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
    toGoods(e) {
      this.params(e, e, "goBuy");
    },
    toggleArrange() {
      this.column = !this.column;
      this.onRefresh();
    },
    changeTab(item, i = 0, focus = false) {
      this.cateId = item.id;
      this.moreVisible = false;
      if (focus) {
        const tabs = this.$refs.tabs;
        const tab = this.$refs[`tab-${i}`][0];
        if (tabs && tab) {
          tabs.scrollTo(
            tab.offsetLeft - tabs.offsetLeft - tabs.offsetWidth / 2,
            0
          );
        }
      }
      this.sort.order = null;
      this.onRefresh();
    },
    changeSort(e) {
      if (this.sort.order == e) {
        this.sort.by = this.sort.by == 0 ? 1 : 0;
      } else if (e) {
        this.sort.order = e;
        this.sort.by == 1;
      } else {
        this.sort.order = null;
      }
      this.onRefresh();
    },
    toPage(e) {
      let params = {
        route_url: e,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "goRouterBS");
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  &.hidden {
    overflow: hidden;
  }
}
.list {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.2rem 0.9rem;
  padding: 0 1rem;

  &.falls {
    grid-template-columns: repeat(2, 1fr);

    /deep/ .van-list__finished-text,
    /deep/ .van-list__error-text,
    /deep/ .van-list__loading,
    /deep/ .van-list__placeholder {
      grid-column: 1 / span 2;
    }
  }

  .item {
    padding: 0.8rem 0.8rem 1.2rem;
    background: #fff;
    border-radius: 0.6rem;
    overflow: hidden;

    &:first-of-type {
      margin-top: 0;
    }

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .date {
        display: flex;
        align-items: center;
        color: #999999;

        .icon {
          width: 1.4rem;
          height: 1.4rem;
          margin-right: 0.4rem;
        }
      }

      .status {
        color: #ff5600;
      }
    }

    .goods {
      margin-top: 1.2rem;
      display: flex;
      align-items: stretch;

      .thumb {
        flex: 0 0 11.2rem;
        height: 11.2rem;
        border-radius: 0.4rem;
        position: relative;
        overflow: hidden;
        margin-right: 0.8rem;

        .icon {
          width: 100%;
          height: 100%;
        }

        .tip {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1.9rem;
          background: rgba(0, 0, 0, 0.69);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 1.2rem;
        }
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 1.3rem;
          height: 3.8rem;
          line-height: 1.9rem;

          &.line3 {
            -webkit-line-clamp: 3;
            height: 5.7rem;
          }
        }

        .desc {
          font-size: 1.2rem;
          color: #999999;
        }

        .price {
          margin-top: 0.2rem;
          color: #333333;

          .rmb {
            font-size: 1.2rem;
          }

          .large {
            font-size: 1.6rem;
            font-weight: 700;
          }

          .small {
            font-size: 1rem;
          }
        }

        .other {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .desc {
            font-size: 1.3rem;

            .del {
              text-decoration: line-through;
            }
          }

          .price {
            margin-top: 0.2rem;
            font-size: 1.3rem;
            color: #ff1515;

            .rmb {
              font-size: 1.2rem;
            }

            .large {
              font-size: 2rem;
              font-weight: 700;
            }
          }

          .btn {
            flex: 0 0 7rem;
            height: 3.6rem;
            background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);
            border-radius: 0.6rem;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 1.2rem;
      border-top: 0.1rem solid #f2f2f2;
      padding-top: 0.8rem;

      .btn {
        padding: 0.7rem 1.4rem;
        font-weight: 700;

        &.active {
          background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);
          box-shadow: 0 0 0.3rem 0 rgba(254, 27, 68, 0.26),
            0 0 1rem 1rem rgba(255, 255, 255, 1);
          border-radius: 1.7rem;
          color: #fff;
        }
      }

      .btn-group {
        border-radius: 1.7rem;
        overflow: hidden;
        display: flex;
        background: #fae3d6;
        color: #ff570b;

        .btn.active {
          border-top-right-radius: 0;
          box-shadow: none;
        }
      }
    }
  }

  .item-column {
    background: #fff;
    border-radius: 1rem;
    overflow: hidden;

    .thumb {
      width: 17.3rem;
      height: 17.3rem;
    }

    .title {
      height: 3.8rem;
      font-size: 1.3rem;
      line-height: 1.9rem;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin: 0.9rem 0.8rem 0;
    }

    .price {
      margin: 0.5rem 0.8rem 0;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .now {
        font-size: 1.2rem;
        color: #ff0000;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .large {
          font-size: 1.8rem;
          font-weight: 700;
        }

        .small {
          font-size: 1rem;
        }
      }

      .old {
        font-size: 1rem;
        text-decoration: line-through;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 0.5rem;
      }
    }

    .btn {
      margin: 0.7rem 1.2rem 0.9rem;
      height: 3.6rem;
      background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);
      border-radius: 0.6rem;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.ad {
  padding: 1.2rem 1.2rem 0;
  background: url(~@/assets/groupRob/top-bg.png);
  background-size: 100% 25.1rem;
  background-repeat: no-repeat;
  background-position-y: calc(-4.4rem - var(--status-height));

  .swiper {
    position: relative;
    border-radius: 1.4rem;
    overflow: hidden;

    .van-swipe-item {
      height: 16.8rem;
      border-radius: 1.4rem;
      overflow: hidden;

      .icon {
        width: 100%;
        height: 100%;
      }
    }

    .indicator {
      display: flex;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0.7rem;

      .item {
        width: 0.8rem;
        height: 0.3rem;
        margin-left: 0.4rem;
        border-radius: 0.2rem;
        background: rgba(255, 255, 255, 0.7);

        &.active {
          background: #fff;
        }
      }
    }
  }
}

.block {
  height: 4.4rem;
  overflow: visible;
  background: #eeeeee;
  position: sticky;
  top: 0;
  z-index: 1001;

  .tabs {
    height: 4.4rem;
    display: flex;
    align-items: center;
    color: #666666;
    padding: 0 1.2rem;

    .items {
      flex: 1;
      overflow: auto;
      white-space: nowrap;

      &::-webkit-scrollbar {
        display: none;
      }

      .item {
        display: inline-block;
        margin: 0 1rem;

        &:first-of-type {
          margin-left: 0;
        }

        &.active {
          font-size: 1.6rem;
          color: #333333;
          font-weight: 700;
        }
      }
    }

    .more {
      display: flex;
      align-items: stretch;
      background: url(~@/assets/groupRob/more-bg.png);
      background-size: 7.5rem 4rem;
      background-position: -0.6rem center;
      padding-left: 1.5rem;

      .label {
        display: flex;
        align-items: center;
        margin-right: 0.3rem;
      }

      .icon {
        align-self: center;
        width: 1rem;
        height: 0.6rem;

        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }

  .navs {
    z-index: 1001;
    background: #eeeeee;
    border-radius: 0 0 1rem 1rem;
    position: relative;
    padding: 0.8rem 1.2rem 1.2rem;
    // display: grid;
    // grid-template-columns: repeat(4, 1fr);
    // grid-auto-rows: 2.8rem;
    // gap: 1.3rem 1.1rem;
    display: flex;
    flex-wrap: wrap;
    margin: -0.55rem -0.65rem;

    .item {
      margin: 0.55rem;
      white-space: nowrap;
      height: 2.8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 1.4rem;
      background: #fff;
      color: #666666;
      padding: 0 1.2rem;

      &.active {
        font-weight: 700;
        color: #f9591b;
      }
    }
  }
}

.shadow-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  // overflow: hidden;

  // & > .scroll {
  //   overflow: auto;
  //   flex: 1;

  //   .container {
  //     min-height: 100%;
  //   }
  // }

  .nav-shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.49);
    z-index: 999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;

    &.show {
      opacity: 1;
      pointer-events: all;
    }
  }
}

.tools {
  height: 4.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1.2rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #eeeeee;

  &.t {
    top: 4.4rem;
  }

  .sort {
    display: flex;
    align-items: center;

    .item {
      padding: 0 1.2rem;
      height: 2.8rem;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 1.4rem;
      margin-right: 2rem;

      &.active {
        font-weight: 700;
        color: #f9591b;
      }

      .icon {
        width: 0.9rem;
        height: 1.2rem;
        margin-left: 0.3rem;
      }
    }
  }

  .toggle {
    width: 1.8rem;
    height: 1.8rem;
  }
}
</style>
